import React from "react";
import './chaistyle.css';
export default function Home()
{
    return(

<section className="sec" id="home">
        <header>
          <a href="#home"><img src="./logo.png" className="logo" /></a>
          <div className="toggleMenu" onClick={menuToggle} />
          <ul className="navigation">
            <li><a href="#products">Products</a></li>
            <li><a href="#Whatsnew">What's New</a></li>
            <li><a href="#About">About</a></li>
            <li><a href="#Contact">Contact</a></li>
          </ul>
        </header>
        <div className="content">
          <div className="textBox">
            <h2>Tea Talk Point<br /><span>Sharing happiness and best taste all over India.</span></h2>
            <p>Tea Talk Point is known for the comfort and happiness its atmosphere provide, and  a place to relax and enjoy the company of others.<br /> Our Special Chai are known for its excellent quality and taste and is enjoyed by people all over India.</p>
            <a href="#products">View All Products</a>
          </div>
          <div className="imgBox">
            <div className="container">
              <div className="plate" />
              <div className="cup">
                <div className="top">
                  <div className="vapour">
                    <span style={{"--i":"1"}} />
                    <span style={{"--i":"3"}} />
                    <span style={{"--i":"16"}} />
                    <span style={{"--i":"5"}} />
                    <span style={{"--i":"13"}} />
                    <span style={{"--i":"20"}} />
                    <span style={{"--i":"6"}} />
                    <span style={{"--i":"7"}} />
                    <span style={{"--i":"10"}} />
                    <span style={{"--i":"8"}} />
                    <span style={{"--i":"17"}} />
                    <span style={{"--i":"11"}} />
                    <span style={{"--i":"12"}} />
                    <span style={{"--i":"14"}} />
                    <span style={{"--i":"2"}} />
                    <span style={{"--i":"9"}} />
                    <span style={{"--i":"15"}} />
                    <span style={{"--i":"4"}} />
                    <span style={{"--i":"19"}} />

                  </div>
                  <div className="circle">
                    <div className="tea" />
                  </div>
                </div>
                <div className="handle" />
              </div>
            </div>            
          </div>
        </div>
        <ul className="sci">
          <li><a href="#"><img src="./facebook.png" /></a></li>
          <li><a href="#"><img src="./twitter.png" /></a></li>
          <li><a href="#"><img src="./instagram.png" /></a></li>
        </ul>
      </section>

    );

}

function menuToggle()
      {
          const toggleMenu=document.querySelector('.toggleMenu');
          const navigation=document.querySelector('.navigation');
          toggleMenu.classList.toggle('active');
          navigation.classList.toggle('active');

            // Close the menu if the user clicks on the "Products", "About", or "What's New" links
        const productsLink = document.querySelector('.navigation a[href="#products"]');
        const aboutLink = document.querySelector('.navigation a[href="#About"]');
        const whatsnewLink = document.querySelector('.navigation a[href="#Whatsnew"]');
        const contactLink = document.querySelector('.navigation a[href="#Contact"]');
        productsLink.addEventListener('click', () => {
          toggleMenu.classList.remove('active');
          navigation.classList.remove('active');
        });
        aboutLink.addEventListener('click', () => {
          toggleMenu.classList.remove('active');
          navigation.classList.remove('active');
        });
        whatsnewLink.addEventListener('click', () => {
          toggleMenu.classList.remove('active');
          navigation.classList.remove('active');
        });
        contactLink.addEventListener('click', () => {
          toggleMenu.classList.remove('active');
          navigation.classList.remove('active');
        });
      }

      
      

